// localeHydrator.ts
import { toCanonical } from "@repo/locale";
import type { AppDispatch } from "@repo/store";

import { getSessionPreferences } from "@repo/ui/helpers/cookies";

import { setCurrency, setLocale, setLocaleAndCurrency } from "@repo/store/slices";

export async function hydrateLocaleFromSession(
  dispatch: AppDispatch,
  sessionId: string | null,
  previousLocale?: string | undefined,
  previousCurrency?: string | undefined,
) {
  if (!sessionId) return { locale: previousLocale, currency: previousCurrency };

  const authData = await getSessionPreferences(sessionId);
  if (!authData) return { locale: previousLocale, currency: previousCurrency };

  const newLocale = toCanonical(authData.locale || "es_cl") ?? null;
  const newCurrency = authData.currency ?? null;

  const updates: { locale?: string; currency?: string } = {};

  if (newLocale && newLocale !== previousLocale) updates.locale = newLocale;
  if (newCurrency && newCurrency !== previousCurrency) updates.currency = newCurrency;

  if (updates.locale && updates.currency) {
    dispatch(setLocaleAndCurrency(updates as Required<typeof updates>));
  } else if (updates.locale) {
    dispatch(setLocale(updates.locale));
  } else if (updates.currency) {
    dispatch(setCurrency(updates.currency));
  }

  return {
    locale: updates.locale ?? previousLocale,
    currency: updates.currency ?? previousCurrency,
  };
}
